<app-general-search-input [title]="title | translate">
  <ng-template>
    <div class="form d-flex flex-column gap-3">
      <div *ngFor="let customerSegment of customerSegmentTypes">
        <mat-checkbox
          class="easy-checkbox"
          (change)="customerValueChanged(customerSegment)"
          [checked]="
            (customerSegment === 'RETAILER' &&
              retailerSelection.hasValue() &&
              isAllRetailerSegmentSelected()) ||
            (customerSegment !== 'RETAILER' &&
              customerSelection.isSelected(customerSegment))
          "
          [indeterminate]="
            customerSegment === 'RETAILER' &&
            retailerSelection.hasValue() &&
            !isAllRetailerSegmentSelected()
          "
          >{{
            "SHARED.CUSTOMER_SEGMENT." + customerSegment | translate
          }}</mat-checkbox
        >
        <div
          *ngIf="customerSegment === 'RETAILER'"
          class="mt-3 d-flex flex-column gap-3"
        >
          <div
            *ngFor="let retailerSegments of retailerSegmentTypes"
            class="ms-4"
          >
            <mat-checkbox
              class="easy-checkbox"
              [checked]="retailerSelection.isSelected(retailerSegments)"
              (change)="retailerValueChanged(retailerSegments)"
              >{{
                "SHARED.CUSTOMER_SEGMENT." + retailerSegments | translate
              }}</mat-checkbox
            >
          </div>
        </div>
        <div></div>
      </div>
    </div>
  </ng-template>
</app-general-search-input>
